import { useCallback, useMemo } from "react";

export const useCalcPecentage = (data: any[]) => {
  const calcCount = useCallback(
    (type: string) => {
      if (data) {
        const values: any[] = data.filter((item: any) => item.type === type);

        return values[values.length - 1]?.value || 0;
      }

      return 0;
    },
    [data],
  );

  const desktopCount: number = useMemo(() => calcCount("Desktop"), [calcCount]);

  const mobileCount: number = useMemo(() => calcCount("Mobile"), [calcCount]);

  const desktopPercentage: number = useMemo(() => {
    return !(desktopCount === 0 && mobileCount === 0)
      ? (desktopCount * 100) / (desktopCount + mobileCount)
      : 0;
  }, [desktopCount, mobileCount]);

  const mobilePercentage: number = useMemo(
    () =>
      !(desktopCount === 0 && mobileCount === 0) ? 100 - desktopPercentage : 0,
    [desktopCount, desktopPercentage, mobileCount],
  );

  return { desktopPercentage, mobilePercentage };
};
